import styles from "./LineTicket.module.css"

function LineTicket({ thisTicket }) {
    return (
        <div className={styles.container}>
            <div className={styles.field}>
                <span>{thisTicket.codigo}</span>
            </div>
            <div className={styles.field}>
                <span className={
                    thisTicket.status === "Pendente" ? styles.novo :
                        thisTicket.status === "Agendada" ? styles.agendada :
                            thisTicket.status === "Finalizado" ? styles.finalizado :
                                styles.andamento
                }>{thisTicket.status}</span>
            </div>
            <div className={styles.field}>
                <span className={styles.checklistId}>{thisTicket.checklistId}</span>
            </div>
            <div className={styles.field}>
                <span>{thisTicket.dataAbertura}</span>
            </div>
        </div>
    )

}

export default LineTicket